import { createStore } from 'vuex'
import catchs from './catchs'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: { catchs },
})
